<template>
  <div class="app">
    <AppHeader/>
    <div class="container">
      <router-view></router-view>
    </div>
    <Footer/>
  </div>
</template>
<script>
import AppHeader from './AppHeader'
import Footer from './Footer'

export default {
  components: {
    AppHeader,
    Footer,
  }
}
</script>
<style lang="scss" scoped>
@import "../../styles/mixins";
@import "../../styles/vars";

.app {
  height: 100%;
}

.container {
  min-height: calc(100% - #{$header-height} - #{$footer-height});
  max-width: $app-width;
  padding: 0 $app-padding;
  margin: 0 auto;
}
</style>
